import React from 'react';
import Box from '@mui/material/Box';

interface DropIndicatorProps {
  position: 'before' | 'after';
  visible: boolean;
}

function DropIndicator({ position, visible }: DropIndicatorProps) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        [position === 'before' ? 'top' : 'bottom']: -4,
        left: 0,
        right: 0,
        height: 4,
        backgroundColor: 'primary.main',
        borderRadius: 2,
        zIndex: 10,
        boxShadow: '0 0 8px rgba(25, 118, 210, 0.5)'
      }}
    />
  );
}

export default DropIndicator;
